
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/templates/content",
      function () {
        return require("private-next-pages/templates/content.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/templates/content"])
      });
    }
  